<template>
    <div>
<!--body content start-->

<div id="main-page" class="page-content">

<!--counter style1 start-->

<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-3 col-sm-6">
        <div class="counter">
          <div class="d-flex align-items-center">
            <div class="counter-icon ml-3"> <i class="flaticon-suitcase"></i>
            </div> <span class="count-number" data-to="900" data-speed="4000">900</span>
          </div>
          <h6>Lot's Of Work Completed</h6>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 mt-5 mt-sm-0">
        <div class="counter">
          <div class="d-flex align-items-center">
            <div class="counter-icon ml-3"> <i class="flaticon-experience"></i>
            </div> <span class="count-number" data-to="20" data-speed="4000">20</span>
          </div>
          <h6>Years of Experience</h6>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 mt-5 mt-lg-0">
        <div class="counter">
          <div class="d-flex align-items-center">
            <div class="counter-icon ml-3"> <i class="flaticon-trophy"></i>
            </div> <span class="count-number" data-to="400" data-speed="4000">400</span>
          </div>
          <h6>Best Awards Winning</h6>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 mt-5 mt-lg-0">
        <div class="counter">
          <div class="d-flex align-items-center">
            <div class="counter-icon ml-3"> <i class="flaticon-rating"></i>
            </div> <span class="count-number" data-to="950" data-speed="4000">950</span>
          </div>
          <h6>Reviews from clients</h6>
        </div>
      </div>
    </div>
  </div>
</section>

<!--counter style1 end-->


<!--counter style2 start-->

<section class="dark-bg parallaxie" data-bg-img="images/pattern/01.png">
  <div class="container">
    <div class="row">
      <div class="col-lg-3 col-sm-6">
        <div class="counter">
          <div class="d-flex align-items-center">
            <div class="counter-icon ml-3"> <i class="flaticon-suitcase"></i>
            </div> <span class="count-number" data-to="900" data-speed="4000">900</span>
          </div>
          <h6>Lot's Of Work Completed</h6>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 mt-5 mt-sm-0">
        <div class="counter">
          <div class="d-flex align-items-center">
            <div class="counter-icon ml-3"> <i class="flaticon-experience"></i>
            </div> <span class="count-number" data-to="20" data-speed="4000">20</span>
          </div>
          <h6>Years of Experience</h6>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 mt-5 mt-lg-0">
        <div class="counter">
          <div class="d-flex align-items-center">
            <div class="counter-icon ml-3"> <i class="flaticon-trophy"></i>
            </div> <span class="count-number" data-to="400" data-speed="4000">400</span>
          </div>
          <h6>Best Awards Winning</h6>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 mt-5 mt-lg-0">
        <div class="counter">
          <div class="d-flex align-items-center">
            <div class="counter-icon ml-3"> <i class="flaticon-rating"></i>
            </div> <span class="count-number" data-to="950" data-speed="4000">950</span>
          </div>
          <h6>Reviews from clients</h6>
        </div>
      </div>
    </div>
  </div>
</section>

<!--counter style2 end-->


<!--counter style3 start-->

<section class="theme-bg">
  <div class="container">
    <div class="row">
      <div class="col-lg-3 col-sm-6">
        <div class="counter">
          <div class="d-flex align-items-center">
            <div class="counter-icon ml-3"> <i class="flaticon-suitcase"></i>
            </div> <span class="count-number" data-to="900" data-speed="4000">900</span>
          </div>
          <h6>Lot's Of Work Completed</h6>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 mt-5 mt-sm-0">
        <div class="counter">
          <div class="d-flex align-items-center">
            <div class="counter-icon ml-3"> <i class="flaticon-experience"></i>
            </div> <span class="count-number" data-to="20" data-speed="4000">20</span>
          </div>
          <h6>Years of Experience</h6>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 mt-5 mt-lg-0">
        <div class="counter">
          <div class="d-flex align-items-center">
            <div class="counter-icon ml-3"> <i class="flaticon-trophy"></i>
            </div> <span class="count-number" data-to="400" data-speed="4000">400</span>
          </div>
          <h6>Best Awards Winning</h6>
        </div>
      </div>
      <div class="col-lg-3 col-sm-6 mt-5 mt-lg-0">
        <div class="counter">
          <div class="d-flex align-items-center">
            <div class="counter-icon ml-3"> <i class="flaticon-rating"></i>
            </div> <span class="count-number" data-to="950" data-speed="4000">950</span>
          </div>
          <h6>Reviews from clients</h6>
        </div>
      </div>
    </div>
  </div>
</section>

<!--counter style3 end-->

</div>

<!--body content end--> 

    </div>
</template>

<script>
export default {
    data: function () {
        return {
            name: "shortcode-counter",
        }
    }
}
</script>